<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import ViewSource from '../components/ViewSource.svelte'

  let scrollText1, scrollText2, clientWidth, hugeTextEl, pinEl, st, tl, scrolled = false

  onMount(() => {
    const h1El = hugeTextEl.querySelectorAll('h1')
    
    createTimeline(h1El)

    st = ScrollTrigger.create({
      trigger: pinEl,
      pin: true,
      scrub: 0.5,
      start: 'top 100px',
      end: '+=900',
      pinSpacing: true,
      animation: tl,
      onRefresh: () => {
        createTimeline(h1El)
      }
    })
  })

  function createTimeline (h1El) {
    tl?.kill()
    scrolled = false
    tl = gsap.timeline({
      paused: true,
      onStart: () => {scrolled = true},
      onReverseComplete: () => {scrolled = false},
    })
    tl.from(h1El, {
      x: clientWidth/2,
      ease: 'power1.out',
      stagger: 1,
      duration: 2,
      force3D: true
    }, 0)
    tl.from(h1El, {
      filter: 'blur(40px)',
      opacity: 0,
      duration: 1,
      ease: 'none',
      stagger: 1,
    }, 0)
    tl.add(() => {}, '+=1')
  }

  onDestroy(() => {
    st?.kill()
    tl?.pause().kill()
  })

</script>

<section class="part1 no-max-width">
  <div class="content">
    <div class="rgrid-md-3-4">
      <div class="col">
        <AnimatedLine size={5} color="white" />
        <AnimatedTitle class="large" style="maskup">Say “hello” to a better way to buy.</AnimatedTitle>
        <AnimatedTitle class="medium subtitle1" delay={0.5} triggerStart="top center"><span class="nowrap">The 2020-21</span> Upfronts were down due to COVID-19’s impact on production and live sports, but Upfronts aren’t going away...</AnimatedTitle>
      </div>
    </div>
  </div>
  <div bind:this={pinEl}>
    <div class="content">
      <div bind:clientWidth={clientWidth} class="huge-text-wrap">
        <div class="huge-text" bind:this={hugeTextEl} class:scrolled={scrolled}>
          <h1 bind:this={scrollText1}>they’re</h1>
          <h1 bind:this={scrollText2}>evolving</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="part1b">
  <div class="stats row col-1-2">
    <div class="col">
      <AnimatedLine size={3} desktopSize={5} color="red" />
      <p><strong class="accent">Activating your upfront buys separately per partner leads to siloed reporting,</strong> which lacks insight into holistic reach and frequency. Reporting is not done in real-time and only offers basic metrics, such as pacing, overdelivery and underdelivery.</p>
    </div>
    <div class="col">
      <AnimatedLine size={3} desktopSize={5} color="red" />
      <p><strong class="accent">Last year,</strong> an estimated 25-30% of upfront budgets went to streaming inventory. As the OTT portion of the Upfronts grows, advertisers stand to gain significant efficiencies by activating their upfront buys programmatically via a DSP.</p>
      <ViewSource id="25_30_upfront_budgets">Digiday, Oct 2020</ViewSource>
    </div>
  </div>
</section>

<style>
  section :global(.hline) {
    margin-bottom: 1rem;
  }
  .huge-text {
    position: relative;
    padding-top: 20px;
    padding-bottom: 20px;
    overflow: hidden;
  }
  .huge-text h1 {
    font-size: 86px;
    white-space: nowrap;
    margin-bottom: 0;
  }
  @media(min-width: 420px) {
    .huge-text h1 {
      font-size: 22vw;
    }
  }
  section :global(.subtitle1) {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .stats p {
    margin: 0.5rem 0 0;
  }
  .part1b {
    margin-top: 3rem;
  }
  .huge-text-wrap {
    margin-right: calc(0px - var(--gutter-sm))
  }
  @media(min-width: 768px) {
    .huge-text-wrap {
      margin-right: calc(0px - var(--gutter-lg))
    }
  }
  @media(min-width: 1024px) {
    .huge-text {
      height: auto;
    }
    .huge-text h1 {
      font-size: 228px;
      margin-bottom: -10px;
    }
    .part1b {
      margin-top: 4rem;
    }
  }
  @media(min-width: 1272px) {
    .huge-text-wrap {
      margin-right: calc(0px - (100vw - var(--max-width)) / 2 - var(--gutter-lg))
    }
  }
</style>